import { render } from "./PerformanceDashboard.vue?vue&type=template&id=374316ca&scoped=true"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=js"

import "./PerformanceDashboard.vue?vue&type=style&index=0&id=374316ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374316ca"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
